$(document).ready(function() {
  
   var allowClickAction = false;
    // Run this after initial page load is complete
      

  $(document).on('input change', '.product-custom-field-input', function() {
    var selectedRadio = $('input[type="radio"][name^="Image-1"]:checked');
    const items = $('.thumbnail-list li.thumbnail-list__item');
    const sixthLast = items.eq(-6);
    const fifthLaft = items.eq(-5);
    const fourthLast = items.eq(-4);
    const thirdLast = items.eq(-3);
    const secondLast = items.eq(-2);
    const last = items.eq(-1);

    sixthLast.css('display', 'block');
    fifthLaft.css('display', 'block');
    fourthLast.css('display', 'block');
    thirdLast.css('display', 'block');
    secondLast.css('display', 'block');
    last.css('display', 'block');
    
    sixthLast.addClass('sixth-last');       // for third last item
    fifthLaft.addClass('fifth-last');       // for third last item
    fourthLast.addClass('fourth-last');       // for third last item
    thirdLast.addClass('third-last');       // for third last item
    secondLast.addClass('second-last');     // for second last item
    last.addClass('last');

    setTimeout(function() {
          allowClickAction = true;
      }, 1000);

    console.log(selectedRadio.val());
    if (selectedRadio.val() == 'Male') {
      if(  allowClickAction &&  $('.thumbnail-list .third-last button').attr('aria-current') !== 'true' ) {
        $('.thumbnail-list .third-last button').trigger("click");
      }
      fifthLaft.css('display', 'none');
      fourthLast.css('display', 'none');
      secondLast.css('display', 'none');
      last.css('display', 'none');
      var overlayContainer = $('.product__media-wrapper .third-last-male .product-media-container');
    } else if(selectedRadio.val() == 'Female') {
     
      
      if( allowClickAction &&  $('.thumbnail-list .second-last button').attr('aria-current') !== 'true' ) {
        $('.thumbnail-list .second-last button').trigger("click");
      }

      sixthLast.css('display', 'none');
      fourthLast.css('display', 'none');
      thirdLast.css('display', 'none');
      last.css('display', 'none');

      var overlayContainer = $('.product__media-wrapper .second-last-female .product-media-container');
    } else if(selectedRadio.val() == 'Al-Aqsa') {
      
      if( allowClickAction &&  $('.thumbnail-list .last button').attr('aria-current') !== 'true' ) {
        $('.thumbnail-list .last button').trigger("click");
      }

      sixthLast.css('display', 'none');
      fifthLaft.css('display', 'none');
      thirdLast.css('display', 'none');
      secondLast.css('display', 'none');

      var overlayContainer = $('.product__media-wrapper .last-dome .product-media-container');

    } else {
      console.log('the else statement');
    }
    
    var parentContainer = $(this).closest('.product-custom-field-input-container');
    var inputVal = $(this).val();
    var labelText = parentContainer.siblings('label').text().toLowerCase();
  
    var event_text = $(this).siblings('label').text().toLowerCase();

    var overlayClass = '';
    var overlayText = '';

    if (labelText.includes('name')) {
        document.querySelector('#product-custom-field-6883a4995df00255eaf6895a').addEventListener('keydown', function(e) {
            // Allow: Backspace, Delete, Tab, Arrow Keys, etc.
            if ([8, 9, 37, 38, 39, 40, 46].includes(e.keyCode)) return;
          
            // Block if NOT a letter (A-Z, a-z)
            if (!(e.keyCode >= 65 && e.keyCode <= 90)) {
                shrinkOverlayText('.overlay-text.name-overlay');
                e.preventDefault();
            }
        });
        shrinkOverlayText('.overlay-text.name-overlay');

        document.querySelector('#product-custom-field-6883a4995df00255eaf6895a').addEventListener('keyup', function(e) {
            shrinkOverlayText('.overlay-text.name-overlay');
        });

      overlayClass = 'name-overlay';
      overlayText = inputVal;
    } else if (event_text.includes('event') || labelText.includes('event')) {
      overlayClass = 'event-overlay';
      overlayText = inputVal;
      if ($(this).is('select')) {
        $('.product-custom-field-input').each(function () {
          if ($(this).is('input[type="text"]')) {
            if( $(this).parents('.product-custom-field-input-container').siblings('label').text().toLowerCase().includes('event') ) {
              var spaceKeyEvent = $.Event('keydown', {
                keyCode: 32,
                which: 32
              });
              $(this).val(inputVal).trigger('focus').trigger(spaceKeyEvent);
              $('input[name="properties[Event]"]').val(inputVal);
            }
          }
        });
      }
    } else if (event_text.includes('message') || labelText.includes('message')) {
      overlayClass = 'message-overlay';
      overlayText = inputVal;
      if ($(this).is('select')) {
        $('.product-custom-field-input').each(function () {
          if ($(this).is('input[type="text"]')) {
            if( $(this).parents('.product-custom-field-input-container').siblings('label').text().toLowerCase().includes('message') ) {
              var spaceKeyEvent = $.Event('keydown', {
                keyCode: 32,
                which: 32
              });
              $(this).val(inputVal).trigger('focus').trigger(spaceKeyEvent);
              $('input[name="properties[Special Message]"]').val(inputVal);
            }
          }
        });
      }
    } else {
      console.log("Other input:", inputVal);
      return;
    }

    console.log(overlayClass);
    // Find the specific overlay div inside the container (name, event, message)

      // Always ensure wrapper exists
      var wrapper = overlayContainer.find('.overlay-wrapper');
      var wrapper1 = overlayContainer.find('.overlay-wrapper-1');
   

      if (wrapper.length === 0) {
        wrapper = $('<div class="overlay-wrapper"></div>');
        overlayContainer.css('position', 'relative').append(wrapper);
      }

      if (wrapper1.length === 0) {
        wrapper1 = $('<div class="overlay-wrapper-1"></div>');
        overlayContainer.css('position', 'relative').append(wrapper1);
      }

      // Now handle overlay inside the wrapper
      var existingOverlay = wrapper.find('.' + overlayClass);
      var existingOverlay1 = wrapper1.find('.' + overlayClass);

      console.log(overlayClass);
      if(overlayClass.includes('name')) {
        console.log('inside male if condition');
        if (existingOverlay.length === 0) {
            var newDiv = $('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText);
            wrapper.append(newDiv);
        } else {
            existingOverlay.text(overlayText);
        }
      } else { 
        console.log('inside male else condition');
        if (existingOverlay1.length === 0) {
            var newDiv = $('<div class="overlay-text ' + overlayClass + '"></div>').text(overlayText);
            wrapper1.append(newDiv);
        } else {
            existingOverlay1.text(overlayText);
        }
      }


  
 
  });

  $(document).on('change', '[id^="variant-selects-template--"] input[type="radio"]', function() {

    // Check if any .product-custom-field-input has a value
    var hasValue = false;
    $('.product-custom-field-input').each(function() {
        if ($(this).val() !== "") {
            hasValue = true;  // If any input has a value, set flag to true
            return false;  // Exit loop once a value is found
        }
    });

    // If there is a value in any of the inputs, trigger the input event after a timeout
     if (hasValue) {


      
     
        setTimeout(function() {

 const isMobile = window.innerWidth <= 768; 




  // if(!isMobile){ $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');  console.log("no mobile"); }

 // ✅ Also update name field on variant change

      const nameInputSelector = '[id^="product-custom-field-"][name="6883a4995df00255eaf6895a"]';
      function fillNameField(value) {
        const input = document.querySelector(nameInputSelector);
        if (!input) return;


      
        const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        nativeSetter.call(input, value);
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));

        // ✅ Prevent input from being focused (in case any script tries)
        input.blur();
      }

          // const selectedRadio = $('input[type="radio"][name^="Image-1"]:checked');
          // const variantTitle = selectedRadio?.val()?.trim().toLowerCase() || "";

          // if (variantTitle.includes("female")) {
          //   fillNameField("FATIMA");
          // } else if (variantTitle.includes("male")) {
          //   fillNameField("ISMAIL");
          // } else if (variantTitle.includes("al-aqsa")) {
          //   fillNameField("ISMAIL");
          // }

            $('.product-custom-field-input').trigger('input');

            console.log("testing");
            
            document.activeElement?.blur();
               if(!isMobile){ $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');  console.log("no mobile"); }
            
            if(isMobile){ 
              
              window.scrollTo({ top: 0, behavior: 'smooth' }); 
             setTimeout(function() {

              console.log("mobile");
              $('.thumbnail-list .thumbnail-list__item:first-child button').trigger('click');
            }, 100);
          
          }

            
           
        }, 1000); // 1000ms timeout
    }
  });
  

function showLoader() {
  const loader = document.querySelector('.product-form__submit .loading__spinner');
  const btn = document.querySelector('.product-form__submit');

  if (loader) loader.classList.remove('hidden');

  if (btn) {
    btn.classList.add('loaderbtn');
    btn.disabled = true;
  }
}

function hideLoader() {
  const loader = document.querySelector('.product-form__submit .loading__spinner');
  const btn = document.querySelector('.product-form__submit');

  if (loader) loader.classList.add('hidden');

  if (btn) {
    btn.classList.remove('loaderbtn');
    btn.disabled = false;
  }
}


  $(document).ready(function() {
    // Listen for Add to Cart button click
     $('.product-form__submit').on('click', function(event) {

      console.log('add to cart button clicked');
      event.preventDefault();
      showLoader();

      var customEventInput = document.querySelector('input[name="properties[Custom Event]"]');
      var eventInput = document.querySelector('input[name="properties[Event]"]');

      if (customEventInput && customEventInput.value.trim() !== '') {
        if (eventInput) eventInput.value = '';
      }

      var customMessageInput = document.querySelector('input[name="properties[Custom Special Message]"]');
      var messageInput = document.querySelector('input[name="properties[Special Message]"]');

      if (customMessageInput && customMessageInput.value.trim() !== '') {
        if (messageInput) messageInput.value = '';
      }

      var formData = $(this).closest('form').serialize();

      // ✅ IMPORTANT: add sections for drawer update
      formData += '&sections=cart-drawer,cart-icon-bubble';
      formData += '&sections_url=' + window.location.pathname;

      console.log(formData);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',

        success: function(response) {

          hideLoader();
          console.log('Cart response:', response);

          const cartDrawer = document.querySelector('cart-drawer');

          // ✅ PRIMARY FIX (Dawn / modern themes)
          if (cartDrawer && response.sections) {

            cartDrawer.renderContents({
              sections: response.sections
            });

            // 🔥 FIX: important for first item (empty cart issue)
            cartDrawer.classList.remove('is-empty');

            // ✅ Open drawer
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('active');
              document.body.classList.add('overflow-hidden');
            }

          } else {

            // 🔁 FALLBACK for custom themes
            fetch('/?sections=cart-drawer,cart-icon-bubble')
              .then(res => res.json())
              .then(data => {

                if (cartDrawer) {
                  cartDrawer.renderContents({
                    sections: data
                  });

                  cartDrawer.classList.remove('is-empty');

                  if (typeof cartDrawer.open === 'function') {
                    cartDrawer.open();
                  } else {
                    cartDrawer.classList.add('active');
                    document.body.classList.add('overflow-hidden');
                  }
                }

              })
              .catch(err => console.error(err));
          }

        },

        error: function(response) {
          hideLoader();
          console.log("Error:", response);
        }
      });

    });

    
  });

  // Create a MutationObserver to watch for changes in the DOM
    var observer = new MutationObserver(function(mutationsList, observer) {

        const items = $('.product__media-list li.product__media-item');
        const thirdLast = items.eq(-3);
        const secondLast = items.eq(-2);
        const last = items.eq(-1);

        thirdLast.addClass('third-last-male');       // for third last item
        secondLast.addClass('second-last-female');     // for second last item
        last.addClass('last-dome');


            // If all elements are found, append the images
            // if ($('.product__media-wrapper .third-last-male .overlay-image').length === 0) {
            //     var firstImage = $('<img class="overlay-image manover" src="https://cdn.shopify.com/s/files/1/0342/8912/3459/files/man-overlay.png?v=1752239874" style="position: absolute; bottom: 0; width: 100%; z-index: 2;">');
            //     $('.product__media-wrapper .third-last-male .product-media-container').append(firstImage);
            // }

            // if ($('.product__media-wrapper .second-last-female .overlay-image').length === 0) {
            //     var secondImage = $('<img class="overlay-image womanover" src="https://cdn.shopify.com/s/files/1/0342/8912/3459/files/women-overlay.png?v=1752228805" style="position: absolute; bottom: 0; width: 100%; z-index: 2;">');
            //     $('.product__media-wrapper .second-last-female .product-media-container').append(secondImage);
            // }

            // if ($('.product__media-wrapper .last-dome .overlay-image').length === 0) {
            //     var thirdImage = $('<img class="overlay-image domeover" src="https://cdn.shopify.com/s/files/1/0342/8912/3459/files/dome-overlay-1.png?v=1753449955" style="position: absolute; bottom: 0; width: 100%; z-index: 2;">');
            //     $('.product__media-wrapper .last-dome .product-media-container').append(thirdImage);
            // }

            // Stop observing once the images have been appended
            observer.disconnect();
        
    });

    // Start observing the document for changes
    observer.observe(document, {
        childList: true,
        subtree: true
    });


  // Function to observe when the target element appears in the DOM
  function checkForElement() {
      const targetNode = document.body;
      const observer_event = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
              $(mutation.addedNodes).each(function() {
                  if ($(this).find('.product-custom-field-input-container')) {

                      var condition = false;
                      $('.product-custom-field-input-container').find('.product-custom-field-input').each(function() {
                          if ($(this).val() !== '') {
                              $(this).trigger('input');
                              $(this).trigger('change');
                          }
                          condition = true;
                      });

                      if(condition){
                        observer_event.disconnect();
                      }
                  }
              });
          });
      });
  
      observer_event.observe(targetNode, {
          childList: true,
          subtree: true
      });
  }
  
  checkForElement();




});







$(document).ready(function() {
  // Check when custom fields are loaded
  var checkElementInterval = setInterval(function() {
    if ($('.product-custom-fields-container .product-custom-field-item').length) {
      clearInterval(checkElementInterval);
      
      $('select.product-custom-field-input').each(function() {
        var $originalSelect = $(this);
        
        // Create swatch container
        var $swatchContainer = $('<div class="swatch-container"></div>');
        
        // Insert swatch container after the original select
        $originalSelect.after($swatchContainer);
        
        // Hide original select but keep it functional
        $originalSelect.css({
          'position': 'absolute',
          'opacity': 0,
          'pointer-events': 'none',
          'height': 0,
          'width': 0
        });
        
        // Add swatch options
        $originalSelect.find('option').each(function() {
  var optionValue = $(this).val();
  var optionText  = $(this).text();
  
  if (optionValue === '') return; // Skip empty option

  $('<div class="swatch-option"></div>')
    .text(optionText)
    .toggleClass('selected', $(this).is(':selected'))
    .click(function(e) {
      if ($swatchContainer.hasClass('dragging')) return;

      // Set select value
      $originalSelect.val(optionValue);

      // Update selected swatch
      $swatchContainer.find('.swatch-option').removeClass('selected');
      $(this).addClass('selected');

      // Trigger both jQuery + native change
      $originalSelect.trigger('change');
      console.log("hi");
      $originalSelect[0].dispatchEvent(new Event("change", { bubbles: true }));

      // Shopify-specific
      if (typeof CustomFields !== 'undefined' && typeof CustomFields.onInputChange === 'function') {
        CustomFields.onInputChange($originalSelect[0]);
      }
    })
    .appendTo($swatchContainer);
});
        
        // Add mouse drag scrolling functionality
        let isDown = false;
        let startX;
        let scrollLeft;

        $swatchContainer.on('mousedown', function(e) {
          isDown = true;
          startX = e.pageX - $swatchContainer.offset().left;
          scrollLeft = $swatchContainer.scrollLeft();
          $swatchContainer.addClass('dragging');
        });

        $(document).on('mouseup', function() {
          isDown = false;
          $swatchContainer.removeClass('dragging');
        });

        $(document).on('mousemove', function(e) {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - $swatchContainer.offset().left;
          const walk = (x - startX) * 2; // Scroll multiplier
          $swatchContainer.scrollLeft(scrollLeft - walk);
        });
        
        // Update selected swatch based on the original select's value (without triggering change event)
        $originalSelect.on('change', function() {
          var val = $(this).val();
          $swatchContainer.find('.swatch-option').removeClass('selected');
          $swatchContainer.find('.swatch-option').filter(function() {
            return $(this).text() === $originalSelect.find('option:selected').text();
          }).addClass('selected');
        });
      });
    }
  }, 100); // Check every 100 milliseconds
});





document.addEventListener("DOMContentLoaded", function () {
  const nameInputSelector = '[id^="product-custom-field-"][name="6883a4995df00255eaf6895a"]';
//   const eventSelectSelector = 'select[name="6883a50c5df00255eaf6895e"]';
  const eventSelectSelector = 'select[name="69369dde256a956bc511f4ee"]';
  const messageSelectSelector = 'select[name="6883a5ff5df00255eaf68971"]';


   
  function fillNameField(value) {
    const input = document.querySelector(nameInputSelector);
    if (!input) return;


   
    const nativeSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
    nativeSetter.call(input, value);
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    // ✅ Prevent input from being focused (in case any script tries)
    input.blur();
  }



  function selectSwatchAndSync(selectEl, textValue) {
    if (!selectEl) return;

    // Swatch selection
    const swatchContainer = selectEl.closest('.product-custom-field-item');
    const swatches = swatchContainer ? swatchContainer.querySelectorAll('.swatch-option') : [];

    swatches.forEach((swatch) => {
      const isMatch = swatch.textContent.trim().toLowerCase() === textValue.toLowerCase();
      swatch.classList.toggle("selected", isMatch);
      if (isMatch) {
        swatch.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
      }
    });

    // Sync <select> value
    for (const opt of selectEl.options) {
      if (opt.textContent.trim().toLowerCase() === textValue.toLowerCase()) {
        selectEl.value = opt.value;
        selectEl.dispatchEvent(new Event("change", { bubbles: true }));
        break;
      }
    }
  }

  function handleVariantCheckAndFill() {
    const selectedVariant = document.querySelector('input[type="radio"][name^="Image-"]:checked');
    const variantTitle = selectedVariant?.value?.trim().toLowerCase() || '';

    const eventSelect = document.querySelector(eventSelectSelector);
    const messageSelect = document.querySelector(messageSelectSelector);





     const existingPreviewButton = document.querySelector('.preview-button');
      if (existingPreviewButton) {
        existingPreviewButton.remove();
      }




        const previewButton = document.createElement('button');
        previewButton.className = 'button preview-button';
        previewButton.innerHTML = `
        <svg viewBox="0 0 1280 1042.0374" width="20" height="20" fill="#fff" class="mr-2">
          <path d="M512 192q-84 0-161 23-77 24-143 66T89 382Q36 441 0 512q36 71 89 130t119 101q66 42 143 66 77 23 161 23t161-23q77-24 143-66t119-101q53-59 89-130-36-71-89-130T816 281q-66-42-143-66-77-23-161-23zm252 170q46 28 83.5 66.5T914 512q-29 45-66.5 83.5T764 662q-56 36-120.5 55T512 736q-67 0-131.5-19T260 662q-46-28-83.5-66.5T110 512q29-45 66.5-83.5T260 362q2-2 5-4l6-4q-7 21-11 43t-4 45q0 53 20 100 20 46 55 81t81 55q47 20 100 20t100-20q46-20 81-55t55-81q20-47 20-100 0-23-4-45t-11-43l6 4q3 2 5 4zm-252 54q0 40-28 68t-68 28q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68z"/>
        </svg> Preview Now`;
        previewButton.type = 'button';

        const productFormButtons = document.querySelector('.product-form__buttons');
        if (productFormButtons) {
          productFormButtons.appendChild(previewButton);
        }


 previewButton.addEventListener('click', function() {

 console.log("click testing mob");
    var selectedRadio = $('input[type="radio"][name^="Image-1"]:checked');
    if (selectedRadio.val() == 'Male') {

      console.log("Male mob");
        const isMobile = window.innerWidth <= 768; 
        if(isMobile){ window.scrollTo({ top: 0, behavior: 'smooth' }); }

      if( $('.thumbnail-list .third-last button').attr('aria-current') !== 'true' ) {
        $('.thumbnail-list .third-last button').trigger("click");
      }
      
    } else if(selectedRadio.val() == 'Female') {
      // $('[id$="__main-5"] button').trigger("click");

      console.log("feMale mob");
        const isMobile_s = window.innerWidth <= 768; 
        if(isMobile_s){ window.scrollTo({ top: 0, behavior: 'smooth' }); }
      if( $('.thumbnail-list .second-last button').attr('aria-current') !== 'true' ) {
        $('.thumbnail-list .second-last button').trigger("click");

        
      }
      
    } else if(selectedRadio.val() == 'Al-Aqsa') {
      // $('[id$="__main-6"] button').trigger("click");

      console.log("al aqsa");
       const isMobile_sq = window.innerWidth <= 768; 
        if(isMobile_sq){ window.scrollTo({ top: 0, behavior: 'smooth' }); }
        
      if( $('.thumbnail-list .last button').attr('aria-current') !== 'true' ) {
        $('.thumbnail-list .last button').trigger("click");
       
      }
    } else {
      console.log('the else statement preview button');
    }

  });



    if (!eventSelect || !messageSelect) return;



    if (variantTitle.includes('female')) {
     
      fillNameField('FATIMA');
      // selectSwatchAndSync(eventSelect, 'For Palestine');
      selectSwatchAndSync(eventSelect, 'For Humanitarian Relief');
      selectSwatchAndSync(messageSelect, 'Because every name counts');
          
    } else if (variantTitle.includes('male')) {

      fillNameField('ISMAIL');
      // selectSwatchAndSync(eventSelect, 'For Palestine');
      selectSwatchAndSync(eventSelect, 'For Humanitarian Relief');
      selectSwatchAndSync(messageSelect, 'Because every name counts');
     
    } else if (variantTitle.includes('al-aqsa')) {
      fillNameField('ISMAIL');
      // selectSwatchAndSync(eventSelect, 'For Palestine');
      selectSwatchAndSync(eventSelect, 'For Humanitarian Relief');
      selectSwatchAndSync(messageSelect, 'Because every name counts');
     
    } else {
      fillNameField('');
    }
     document.activeElement?.blur();
    window.scrollTo(0, 0);

  }





  // Observe DOM changes until fields are found
  const waitForInputs = new MutationObserver(() => {
    const nameInput = document.querySelector(nameInputSelector);
    const eventSelect = document.querySelector(eventSelectSelector);
    const messageSelect = document.querySelector(messageSelectSelector);

    if (nameInput && eventSelect && messageSelect) {
      
      waitForInputs.disconnect();
      setTimeout(handleVariantCheckAndFill, 300);
    }
  });
  waitForInputs.observe(document.body, { childList: true, subtree: true });

  // Watch for manual changes on variant select or swatch radio
  document.body.addEventListener('change', function (e) {
    if (
      e.target.matches('select[name="id"]') ||
      e.target.matches('.product__radio input[type="radio"]')
    ) {
         setTimeout(handleVariantCheckAndFill, 300);
    }
  });

  // Initial trigger after load
  setTimeout(handleVariantCheckAndFill, 1000);
});








function shrinkOverlayText(selector, minFontSize = 0.521) {
    const elements = document.querySelectorAll(selector);

    elements.forEach(el => {
        // Reset to starting size
        const isMobile = window.innerWidth <= 768;
      el.style.fontSize = isMobile ? '15vw' : '6vw';

      const containerWidth = el.clientWidth;
      let fontSize = parseFloat(window.getComputedStyle(el).fontSize) / window.innerWidth * 100; // convert px to vw

      // Shrink text until it fits or reaches minFontSize
      while (el.scrollWidth > containerWidth && fontSize > minFontSize) {
        fontSize -= 0.1;
        el.style.fontSize = fontSize + 'vw';
      }
    });
}

// Run once on page load
shrinkOverlayText('.overlay-text.name-overlay');

// Optional: Run again on window resize for responsiveness
window.addEventListener('resize', () => {
    shrinkOverlayText('.overlay-text.name-overlay');
});



